import { getExist, copyJson } from '../utils/function'
import { getRecoveryType } from './type'
import optionModel from './recovery-fields/option'
import questionModel from './recovery-fields/question'
import optionTypes from './recovery-fields/option-types'
import questionTypes from './recovery-fields/question-types'
import answerModel from './recovery-fields/answer'


/**
 * 修复数据类型，数字与字符串的转换
 * TODO 由于代码逻辑错误造成部分已存在的数据数据类型不正确
 *
 * @param errorData
 * @param rightData
 * @param field
 * @returns {boolean}
 */
function autoFixDataType (errorData, rightData, field) {
  if (
    [Number, String].includes(errorData[field].constructor) ||
    [Number, String].includes(rightData[field].constructor)
  ) {
    errorData[field] = rightData[field].constructor(errorData[field])
    return true
  }
  return false
}

function getQuestionValue (question) {
  // 深复制一个模型
  let $questionModel = copyJson(questionModel)
  let $question = {}
  let fields = questionTypes[question.type]
  // 获得问题的类型
  let type = getRecoveryType(question.type)
  fields.forEach((field) => {
    switch (field) {
      case 'stepId':
        $question[field] = question.id
        break
      case 'type':
        $question[field] = type
        break
      case 'referStepId':
        $question[field] = getExist(question.referIds[0], $questionModel[field])
        break
      case 'desc':
        $question[field] = question.text
        break
      case 'descPrefix':
        $question[field] = question.textPrefix
        break
      case 'images':
        $question[field] = question.images.map(({src}) => src)
        break
      case 'videoDuration':
        $question[field] = question.evidenceType === 'video' ? question.minDuration : $questionModel[field]
        break
      case 'recordDuration':
        $question[field] = question.evidenceType === 'record' ? question.minDuration : $questionModel[field]
        break
      case 'forceCamera':
        $question[field] = !question.localFile
        break
      case 'default_jump':
        $question[field] = question.jumpTargetId
        break
      case 'conditional_jump':
        $question[field] = {}
        question.options.forEach((option) => {
          option.jumpTargetId && ($question[field][option.id] = option.jumpTargetId)
        })
        break
      case 'needPhoto':
        $question[field] = question.needEvidence
        break
      case 'moptions':
        $question[field] = question.options
        break
      case 'pictureMultipleOptions':
        $question[field] = question.options
        break
      case 'mtext':
        $question[field] = question.options
        break
      default :
        // 取得默认字段值
        $question[field] = getExist(question[field], $questionModel[field])
        break
    }
    // 数据类型验证，保证数据是可靠的
    // TODO 默认值为NULL 时没有 constructor，需要更完善的类型申明
    if ($questionModel[field] !== null && $question[field].constructor !== $questionModel[field].constructor) {
      let message = `question "${field}" 数据类型应该是 ${$questionModel[field].constructor.name}, 当前是 ${$question[field].constructor.name}`
      if (autoFixDataType($question, $questionModel, field)) {
        console.error(message)
        console.warn(`自动修复 question "${field}" 数据类型为 ${$questionModel[field].constructor.name}`)
      } else {
        throw new Error(message)
      }
    }
  })
  return $question
}

function getOptionValue (option, type) {
  // 深复制一个模型
  let $optionModel = copyJson(optionModel)
  let $option = {}
  let fields = optionTypes[type]
  fields.forEach((field) => {
    switch (field) {
      case 'optionId':
        $option[field] = option.id
        break
      case 'referStepId':
        $option[field] = getExist(option.referIds[0], $optionModel[field])
        break
      case 'titlePictures':
        $option[field] = option.images.map(({src}) => src)
        break
      case 'examplePhotos':
        $option[field] = option.exampleImages.map(({src}) => src)
        break
      case 'exclusiveOption':
        $option[field] = option.mutexOptions
        break
      case 'mStepDelay':
        $option[field] = option.nextSelectDelay
        break
      case 'forceCamera':
        $option[field] = !option.localFile
        break
      case 'needPhoto':
        $option[field] = option.needEvidence
        break
      case 'settlementAmountRatio':
        // 必须拥有符合的父级设定
        $option[field] = option.settlementType === 1 ? option[field] : $optionModel[field]
        break
      case 'settlementAmount':
        // 必须拥有符合的父级设定
        $option[field] = option.settlementType === 2 ? option[field] : $optionModel[field]
        break
      default :
        // 取得默认字段值
        $option[field] = getExist(option[field], $optionModel[field])
        break
    }
    // 数据类型验证，保证数据是可靠的
    // TODO 默认值为NULL 时没有 constructor，需要更完善的类型申明
    if ($optionModel[field] !== null && $option[field].constructor !== $optionModel[field].constructor) {
      let message = `option "${field}" 数据类型应该是 ${$optionModel[field].constructor.name}, 当前是 ${$option[field].constructor.name}`
      if (autoFixDataType($option, $optionModel, field)) {
        console.error(message)
        console.warn(`自动修复 question "${field}" 数据类型为 ${$optionModel[field].constructor.name}`)
      } else {
        throw new Error(message)
      }
    }
  })

  return $option
}

export function recoveryQuestions (questions) {
  let $questions = []
  questions.forEach((question) => {
    // 获得问题的类型
    let type = question.type
    let $type = getRecoveryType(type)
    let $question = getQuestionValue(question)
    // 选项的转换
    if ($question[$type]) {
      $question[$type] = $question[$type].map(option => getOptionValue(option, type))
    }
    $questions.push($question)
  })
  return $questions
}

export function recoveryAnswers (questions, answers, indexes) {
  let $answers = []
  questions.forEach((question, index) => {
    let answer = answers[index]
    let $answer = copyJson(answerModel)
    $answer.stepId = question.id

    // 生成有效题目的答案数据
    if (!indexes[question.id].isJumped) {
      let {type, evidenceType, options} = question
      let evidences = []
      let texts = {}
      // 多项填空题
      if (type === 'multitext') {
        answer.texts.forEach((vlaue, index) => {
          texts[options[index].id] = {
            textAnswer: vlaue,
          }
        })
      } else {
        // 证据
        evidences = answer.evidences.map(item => {
          if (evidenceType === 'video') {
            return {
              videoUrl: item.src,
              thumbUrl: item.cover,
            }
          } else if (evidenceType === 'qrcode') {
            return {
              ...item,
              src: item.image_url,
            }
          } else {
            return item.src
          }
        })
      }
      $answer = {
        'stepId': question.id,
        'isPassed': answer.isPassed,
        'errormessage': answer.errorMessage,
        'comment': answer.comment,
        'textAnswer': answer.text || '',
        'selectedOptionId': type === 'select' && answer.selectedOptionId[0] ? answer.selectedOptionId[0] : '',
        'mOptionIds': type === 'multiselect' ? answer.selectedOptionId : [],
        'pictureMultipleOptionIds': type === 'imageMultiselect' ? answer.selectedOptionId : [],
        'mTextAnswer': texts,
        'photos': evidenceType === 'photo' ? evidences : [],
        'videos': evidenceType === 'video' ? evidences : [],
        'records': evidenceType === 'record' ? evidences : [],
        'qrcodes': evidenceType === 'qrcode' ? evidences : [],
      }
    }

    $answers.push($answer)
  })
  return $answers
}

export default {recoveryQuestions, recoveryAnswers}



// WEBPACK FOOTER //
// ./src/views/question-editor/format/recovery.js